import { api } from "./api";

type ProfilePrefs = { uiLanguage?: string | null; tutorialMode?: boolean };

let boot: Promise<ProfilePrefs> | null = null;

/**
 * The account's saved UI preferences, read once per page load. The language and
 * tutorial-mode providers both adopt a saved preference at boot, and each used to
 * fetch /profile on its own: two identical requests on every app start.
 */
export function bootProfilePrefs(): Promise<ProfilePrefs> {
  boot ??= api.get<ProfilePrefs>("/profile", { optionalAuth: true });
  return boot;
}
